export default __webpack_public_path__ + "static/media/icon-chevron-right.eecabcce.svg";